import React from "react";
import { useState, useEffect } from "react";

import Form from "../components/form";
import Card from "../components/card";

const Home = () => {
  // const url = "http://localhost:3000/";
  const url = "https://rest-mongodb-blog2022.herokuapp.com/api/blog";

  const [newData, setData] = useState([]);

  const fetchData = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setData(data);
      console.log(data);
    } catch (e) {
      console.log("heloooooo" + e.message);
    }
  };

  useEffect(() => {
    fetchData(url);
  }, [newData]);

  // delete api
  const handleDelete = async (id) => {
    try {
      const response = await fetch(url + `/${id}`, {
        method: "DELETE",
      });
      // const data = await response.json();
      // fetchData();
    } catch (e) {
      console.log(e.message);
    }
  };

  //post api
  const addBlogs = async (blogadd) => {
    // console.log(blogadd);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(blogadd),
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <div>
      Home
      <Form addBlogs={addBlogs} />
      <div className="flex flex-wrap justify-center">
        {newData.map((item) => {
          // const { id, blog, author, createdon } = item;

          return (
            <div key={item.id} className="    ">
              {/* <h1 className="text-2xl text-red-500">{item.title}</h1>
            <p>{blog}</p>
            <p>{author}</p>
            <button
              className="bg-red-500"
              onClick={() => {
                // console.log(`delete button clicked ${id}`);
                handleDelete(id);
              }}
            >
              Delete item
            </button> */}

              <Card cardProps={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Home;
